import { stockAdjustmentListColumns, stockTransferListColumns, type ListColumnSpec } from "@patronix/domain/list";
import { viewSearch, type ViewSearch } from "@/lib/listView";
import type { StatusFilter } from "./api";

// Search params of the document list routes. Kept apart from the page
// component: route config (validateSearch) stays in the entry chunk, so
// anything it imports would be pulled out of the lazily loaded route chunk.

export interface DocumentsSearch extends ViewSearch {
  status: StatusFilter;
  doc?: string | undefined;
  /** The import panel is open (replaces the document detail): opening stock on adjustments, a transfer on transfers. */
  import?: "opening_stock" | "stock_transfers" | undefined;
}

export const statusFilters: StatusFilter[] = ["all", "draft", "posted", "cancelled"];

/** Column spec of a document list (adjustments have a reason column, transfers not). */
export const documentListColumns = { stock_adjustment: stockAdjustmentListColumns, stock_transfer: stockTransferListColumns } as const;

export function documentsSearchValidator(spec: readonly ListColumnSpec[]) {
  return (raw: Record<string, unknown>): DocumentsSearch => {
    const s: DocumentsSearch = {
      status: statusFilters.includes(raw.status as StatusFilter) ? (raw.status as StatusFilter) : "all",
    };
    if (typeof raw.doc === "string" && raw.doc) s.doc = raw.doc;
    if (raw.import === "opening_stock" || raw.import === "stock_transfers") s.import = raw.import;
    return { ...s, ...viewSearch(spec, raw) };
  };
}
